<template>
  <hic-list-page title="辅助录入" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" keyword-placeholder="关键字">
    <template slot="buttons">
      <el-button v-if="permission.emr_knowledge_edit" type="primary" size="small" icon="el-icon-plus" @click="create">新建</el-button>
    </template>
    <template slot="search">
      <el-checkbox v-model="mine" @change="page">我的</el-checkbox>
    </template>
    <el-table-column label="操作" align="center" width="120">
      <template slot-scope="{ row }">
        <el-button v-if="permission.emr_knowledge_edit || row.doctorCode == user.code" title="编辑" type="primary" plain size="mini" circle icon="el-icon-edit" @click="edit(row)" :disabled="row.doctorCode != user.code"></el-button>
        <el-popconfirm v-if="permission.emr_meta_delete" title="确定要删除吗?" icon-color="red" @confirm="del(row)" class="left-pad">
          <el-button slot="reference" v-if="permission.emr_knowledge_delete || row.doctorCode == user.code" title="删除" type="danger" plain size="mini" circle icon="el-icon-delete" :disabled="row.doctorCode != user.code"></el-button>
        </el-popconfirm>
        <el-button v-if="permission.emr_knowledge_edit || row.doctorCode == user.code" title="复制" type="primary" plain size="mini" circle icon="el-icon-document-copy" @click="copy(row)" class="left-pad"></el-button>
      </template>
    </el-table-column>
    <el-table-column label="名称" prop="name" width="150">
      <template slot-scope="{ row }">
        <el-link type="primary" @click="info(row)">
          <b>{{ row.name }}</b>
        </el-link>
      </template>
    </el-table-column>
    <el-table-column label="内容" prop="content" min-width="200" show-overflow-tooltip> </el-table-column>
    <el-table-column column-key="category" :filters="dict.MrCategory" :filter-multiple="false" label="分类目录" prop="category" width="120" align="center">
      <template slot-scope="{ row }"> {{ row.category | dictText("MrCategory") }}</template>
    </el-table-column>
    <el-table-column column-key="mrRange" :filters="dictEnum.MrRange" :filter-multiple="false" label="范围" prop="mrRange" align="center" width="100"></el-table-column>

    <el-table-column sortable="custom" label="引用" prop="times" align="right" width="100">
      <template slot-scope="{ row }"> {{ row.times || 0 }} 次</template>
    </el-table-column>
    <el-table-column column-key="deptCode" :filters="dict.Dept" :filter-multiple="false" label="科室" prop="deptCode" align="center" width="100">
      <template slot-scope="{ row }">
        {{ row.deptCode | dictText("Dept") }}
      </template>
    </el-table-column>
    <el-table-column label="医生" prop="doctorName" align="center" width="100"></el-table-column>
    <el-table-column sortable="custom" label="排序" prop="seqNo" align="center" width="100"></el-table-column>

    <editor v-model="entity" :visible.sync="meta.showEditor" @close="page"></editor>
    <info v-model="entity" :visible.sync="meta.showDetail"></info>
  </hic-list-page>
</template>

<script>
  import { mapGetters } from "sw-hic";
  import store from "@/common/store";
  export default {
    beforeRouteEnter(to, from, next) {
      // 在渲染该组件的对应路由被 confirm 前调用
      // 不！能！获取组件实例 `this`
      // 因为当守卫执行前，组件实例还没被创建
      if (!store.getters.permission.emr_knowledge_query) {
        next({
          name: "err",
          params: { err: cfg.errs.NeedPromission },
        });
      } else {
        next();
      }
    },
    beforeRouteLeave(to, from, next) {
      // 导航离开该组件的对应路由时调用
      // 可以访问组件实例 `this`
      this.meta.showEditor = false;
      this.meta.showDetail = false;
      next();
    },
    components: {
      editor: () => import("./edit"),
      info: () => import("./info"),
    },
    data() {
      return {
        meta: {
          showDetail: false,
          showEditor: false,
          loading: false,
        },
        condition: {
          pageSize: 20,
          pageIndexOnView: 1,
          sort: "seqNo",
          asc: true,
          keyword: null,
        },
        entities: {},
        entity: {},
        mine: false,
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "Enum", "permission", "user"]),
    },
    methods: {
      page() {
        this.meta.loading = true;
        if (this.mine) {
          this.condition.doctorCode = this.user.code;
        } else {
          this.condition.doctorCode = null;
        }
        this.$api.Help.query(this.condition)
          .then((res) => {
            this.entities = res;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      info(row) {
        this.entity = row;
        this.meta.showDetail = true;
      },
      create() {
        this.entity = { deptCode: this.user.deptCode, doctorCode: this.user.code, doctorName: this.user.name };
        this.meta.showEditor = true;
      },
      edit(row) {
        this.entity = this.$utils.Obj.clone(row);
        this.meta.showEditor = true;
      },
      copy(row) {
        this.entity = this.$utils.Obj.clone(row);
        this.entity.id = null;
        this.entity.name = null;

        this.meta.showEditor = true;
      },
      del(info) {
        this.$api.Help.del(info.id)
          .then((res) => {
            this.meta.loading = false;
            this.$message.success("删除成功");
            this.page();
          })
          .catch((err) => {
            this.$message.error(err);
          });
      },
    },
  };
</script>
